export default "__VITE_ASSET__13417b14__"